package ai.flowstorm.studio.ui.design.dialogue.graph

import ai.flowstorm.studio.ui.design.dialogue.GraphEditor
import kotlinx.coroutines.launch
import ai.flowstorm.common.ui.Icon
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.common.ui.form.ListIdSelect
import ai.flowstorm.studio.model.Graph
import ai.flowstorm.studio.resources.space.PersonaResource
import io.kvision.form.text.Text
import io.kvision.i18n.I18n.gettext
import io.kvision.i18n.I18n.tr

class SetPersonaEditor(graphEditor: GraphEditor) : NodeEditor<Graph.SetPersona>(graphEditor) {

    override val form = object : NodeForm(Graph.SetPersona.serializer()) {
        init {
            add(Graph.SetPersona::name, Text(label = tr("Name")),
                required = true,
                validatorMessage = { gettext("Node name must be unique.") },
                validator = { text ->
                    !graphEditor.graph.nodes.any { it.name == text.value && it != node }
                }
            )
            add(
                Graph.SetPersona::type,
                Text(label = tr("Type"))
            )
            add(
                Graph.SetPersona::title,
                Text(label = tr("Title"))
            )
            add(
                Graph.SetPersona::size,
                Text(label = tr("Size"))
            )
            add(
                Graph.SetPersona::persona_ids,
                ListIdSelect(label = tr("Personas")).apply {
                    mainScope.launch {
                        options = UiHelpers.options(PersonaResource.load())
                    }
                }
            )
        }
    }

    override var readOnly: Boolean
        get() = super.readOnly
        set(value) {
            super.readOnly = value
        }
    override val tabPanel = object : NodeTabPanel() {
        init {
            addTab(tr("Properties"), form, Icon.Properties.def)
            activeIndex = 1
        }
    }

    override fun load(node: Graph.SetPersona) {
        super.load(node)
        form.load(node)
    }
}